<template>
  <!-- popup (s) -->
  <div class="popWrap nowOpen modal">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full">
          <div class="popHead">
            <h1 class="titH1">CMS자동이체약관동의</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="titArea">
                  <h2 class="titH4">약관동의</h2>
                </div>

                <!-- 약관 (s) -->
                <div class="termsWrap">
                  <div class="block accoHead">
                    <input type="checkbox" class="ipt" name="terms1" id="terms1_all" />
                    <label for="terms1_all">전체동의</label>
                  </div>

                  <p class="txtXS pointC6 mb10">
                    고객 편의 제공을 위하여 여러 동의사항에 대한 '전체 동의' 기능을 제공하고 있습니다.
                  </p>

                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li>
                        <div class="block accoHead">
                          <input type="checkbox" class="ipt" name="terms1" id="terms1_1" />
                          <label for="terms1_1">자동이체 약관 동의</label>
                          <button type="button" class="btnIco_acco accoBtn"><span class="blind">상세약관 보기</span></button>
                        </div>
                        <div class="accoBody">
                          <ul class="iptGroup">
                            <li>
                              <div class="block">
                                <input type="checkbox" class="ipt" name="terms1" id="terms1_11" />
                                <label for="terms1_11">
                                  <span>[필수]</span>
                                  다행자동이체동의
                                </label>
                                <button type="button" class="links arrow"><span class="blind">상세약관 내용보기</span></button>
                              </div>
                            </li>
                            <li>
                              <div class="block">
                                <input type="checkbox" class="ipt" name="terms1" id="terms1_12" />
                                <label for="terms1_12">
                                  <span>[필수]</span>
                                  개인정보 수집/이용동의
                                </label>
                                <button type="button" class="links arrow"><span class="blind">상세약관 내용보기</span></button>
                              </div>
                            </li>
                            <li>
                              <div class="block">
                                <input type="checkbox" class="ipt" name="terms1" id="terms1_13" />
                                <label for="terms1_13">
                                  <span>[필수]</span>
                                  개인정보 제3자 제공
                                </label>
                                <button type="button" class="links arrow"><span class="blind">상세약관 내용보기</span></button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li>
                        <div class="block accoHead">
                          <input type="checkbox" class="ipt" name="terms1" id="terms1_2" />
                          <label for="terms1_2">휴대폰 본인인증 동의</label>
                          <button type="button" class="btnIco_acco accoBtn"><span class="blind">상세약관 보기</span></button>
                        </div>
                        <div class="accoBody">
                          <ul class="iptGroup">
                            <li>
                              <div class="block">
                                <input type="checkbox" class="ipt" name="terms1" id="terms1_21" />
                                <label for="terms1_21">
                                  <span>[필수]</span>
                                  개인정보 수집/이용동의
                                </label>
                                <button type="button" class="links arrow"><span class="blind">상세약관 내용보기</span></button>
                              </div>
                            </li>
                            <li>
                              <div class="block">
                                <input type="checkbox" class="ipt" name="terms1" id="terms1_22" />
                                <label for="terms1_22">
                                  <span>[필수]</span>
                                  고유식별정보처리 동의
                                </label>
                                <button type="button" class="links arrow"><span class="blind">상세약관 내용보기</span></button>
                              </div>
                            </li>
                            <li>
                              <div class="block">
                                <input type="checkbox" class="ipt" name="terms1" id="terms1_23" />
                                <label for="terms1_23">
                                  <span>[필수]</span>
                                  휴대폰본인확인 이용약관동의
                                </label>
                                <button type="button" class="links arrow"><span class="blind">상세약관 내용보기</span></button>
                              </div>
                            </li>
                            <li>
                              <div class="block">
                                <input type="checkbox" class="ipt" name="terms1" id="terms1_24" />
                                <label for="terms1_24">
                                  <span>[필수]</span>
                                  통신사이용약관동의
                                </label>
                                <button type="button" class="links arrow"><span class="blind">상세약관 내용보기</span></button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 약관 (e) -->

                <div class="formArea">
                  <span class="label">
                    휴대폰번호
                    <span class="required"><span class="blind">필수</span></span>
                  </span>
                  <div class="setAgency">
                    <!-- 알뜰폰 선택 시 클래스추가 : selected -->
                    <ul class="iptGroup iptBtn">
                      <li>
                        <input type="radio" class="ipt" name="rdosort" id="agency_1" checked="checked" />
                        <label for="agency_1">SKT</label>
                      </li>
                      <li>
                        <input type="radio" class="ipt" name="rdosort" id="agency_2" />
                        <label for="agency_2">KT</label>
                      </li>
                      <li>
                        <input type="radio" class="ipt" name="rdosort" id="agency_3" />
                        <label for="agency_3">LGU+</label>
                      </li>
                    </ul>
                    <select class="ipt" id="agency_4" title="통신사 선택">
                      <option value="" selected="selected">알뜰폰</option>
                      <option value="">선택1</option>
                      <option value="">선택2</option>
                    </select>
                  </div>
                  <div class="setPhone">
                    <input type="tel" id="phone_2" class="ipt" title="휴대폰 번호 입력" placeholder="' - ' 없이 입력해주세요." value="" />
                    <button type="button" class="btn_s round s">인증번호요청</button>
                  </div>
                  <div>
                    <input type="tel" id="phone_3" class="ipt addTxt" title="인증번호 입력" placeholder="" value="" />
                    <span class="txt">
                      유효시간
                      <strong class="pointC1">03:00</strong>
                    </span>
                  </div>
                </div>

                <div class="btnArea">
                  <button type="button" class="btn_p">확인</button>
                </div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>

          <button type="button" class="btnIco_close" onclick="lp.close();"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
  <!-- popup (e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front';
export default {
  name: 'ChangeCmsPop',
  mounted() {
    customjs.init();
  },
};
</script>
